import React from 'react';
import { useStore } from 'effector-react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SceneType } from '@types';
import { CollapseWrapper } from '@components/Collapse';
import { $loadedScene } from '@stores/loadedStore';
import PanoView from './PanoView';
import MatrixView from './MatrixView';

function SidebarView() {
  const scene = useStore($loadedScene);
  if (!scene) return null;
  return (
    <Scrollbars>
      <CollapseWrapper>
        {scene.type === SceneType.pano && (
          <PanoView sceneType={SceneType.pano} />
        )}
        {scene.type === SceneType.panoVideo && (
          <PanoView sceneType={SceneType.panoVideo} />
        )}
        {scene.type === SceneType.matrix && <MatrixView />}
      </CollapseWrapper>
    </Scrollbars>
  );
}

export default SidebarView;
